"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.categoryIndexSettingsConfig = void 0;
const defaultAlgoliaIndex_config_1 = require("../defaultAlgoliaIndex.config");
const schemaName_1 = require("../schemaName");
exports.categoryIndexSettingsConfig = {
    schemaName: schemaName_1.SchemaName.category,
    settings: (language) => (Object.assign(Object.assign(Object.assign({}, defaultAlgoliaIndex_config_1.defaultAlgoliaIndexConfig), (0, defaultAlgoliaIndex_config_1.defaultIndexLanguageConfig)(language)), { searchableAttributes: [
            "unordered(name)",
            "unordered(category)",
            'unordered(description)',
            "unordered(keywords)",
            "unordered(occasions)"
        ], attributesToRetrieve: [
            "category",
            "description",
            "ids",
            "keywords",
            "links",
            "name",
            "type"
        ], attributesForFaceting: defaultAlgoliaIndex_config_1.defaultPageFieldConfig.attributesForFaceting, decompoundedAttributes: defaultAlgoliaIndex_config_1.defaultPageFieldConfig.decompoundedAttributes, decompoundQuery: false, ranking: defaultAlgoliaIndex_config_1.defaultPageFieldConfig.ranking, customRanking: [
            'desc(popularity)'
        ], reRankingApplyFilter: [], advancedSyntax: false }))
};
